import * as React from 'react';

function SvgBankTransfer(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={57} height={56} {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.728)">
        <rect width={56} height={56} fill="#E2F4F2" rx={6} />
        <path
          fill="#38B2A6"
          d="M28 42c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14-6.268 14-14 14zm0-3.294c5.913 0 10.706-4.793 10.706-10.706 0-5.913-4.793-10.706-10.706-10.706-5.913 0-10.706 4.793-10.706 10.706 0 5.913 4.793 10.706 10.706 10.706zm-2.059-11.53H21l4.941-5.352v2.058H35v3.294h-9.059zm4.118 1.648H35l-4.941 5.352v-2.058H21v-3.294h9.059z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgBankTransfer;
